import styles from "./EventAboutSection.module.scss";

export const EventAboutSection = () => {
  return (
    <div className={styles.aboutSection}>
      <p className={styles.aboutSection__title}>О мероприятии</p>
      <p className={styles.aboutSection__text}>
        «Азбука Рубцов» — масштабный конгресс, где ведущие эксперты страны
        разбирают стратегии лечения рубцов от А до Я. Участники получат
        передовой мировой опыт, актуальные клинические рекомендации в рамках
        правового поля РФ и готовые протоколы сочетанного применения
        инъекционных и аппаратных методик.
      </p>
    </div>
  );
};
